import React from 'react'

export const List = ({ style = {}, children, props }) => {
  style = {
    margin: '8px 0 14px',
    paddingLeft: '20px',
    ...style
  }

  return (
    <ul style={style} {...props}>
      {children}
    </ul>
  )
}

export const ListItem = ({ props, children }) => {
  return <li {...props}>{children}</li>
}
